"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const FieldControls_1 = __importDefault(require("../controls/FieldControls"));
const MaterialTextField_1 = __importDefault(require("../inputs/MaterialTextField"));
exports.default = (0, mobx_react_1.observer)(({ club }) => (react_1.default.createElement("fieldset", { className: "tc pa3" },
    react_1.default.createElement("div", { className: "cf" },
        react_1.default.createElement("h5", { className: "fl mv0" }, club.label),
        react_1.default.createElement("div", { className: "fr" },
            react_1.default.createElement(FieldControls_1.default, { field: club, 
                // labels={false}
                controls: {
                    onClear: true,
                    onReset: true,
                } }))),
    react_1.default.createElement(MaterialTextField_1.default, { field: club.$('name') }),
    react_1.default.createElement(MaterialTextField_1.default, { field: club.$('city') }),
    react_1.default.createElement("div", null,
        react_1.default.createElement(FieldControls_1.default, { field: club, 
            // labels={false}
            controls: {
                onSubmit: true,
            } })))));
